import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { ReactComponent as SearchIcon } from 'Components/SearchDropdown/icons/search.svg';
import { ReactComponent as DownloadIcon } from 'Icons/download-white.svg';
import {ReactComponent as DeleteIcon} from 'Icons/delete.svg';
import {ReactComponent as WinningIcon } from 'Icons/winning-transporter.svg';
import Sticky from 'Components/Sticky';
import { DateRangePicker } from 'react-dates';
import Dropdown from 'Components/Dropdown';
import ActionLoader from 'Components/ActionLoader';
import Cx from 'classnames';
import { 
    GET_EVENT_DETAILS,
    DELETE_EVENT_DETAILS,
    CREATE_NEW_EVENT,
    DOWNLOAD_EVENT_DETAILS_TEMPLATE
} from 'Constants/actionConstants';
import RFQ from 'Models/RFQ';
import Moment from 'moment';
import { downloadUrl } from 'Utils/index';

const EVENT_STATUS = [
    {name: 'Draft', value: 1},
    {name: 'Scheduled', value: 3},
    {name: 'Completed', value: 5}
]

class eventManagement extends Component {
    constructor() {
        super();
        this.state = {
            filter: {
                search: '',
                eventId: null,
                from: null,
                to: null
            }
        }
    }

    componentDidMount() {
        this.getEventDetails();
    }

    getEventDetails = () => {
        const { dispatch } = this.props;
        const { filter } = this.state;
        const params = {};
        Object.keys(filter).forEach((key, index) => {
            if(filter[key]) {
                params[key] = filter[key]
            }   
        })
        dispatch({
            type: GET_EVENT_DETAILS,
            params
        })
    }

    getStatusColor = (id) => {
        let statusColor = '';
        if(id === 1) {
            statusColor = '#0962A1';
        } else if(id === 2) {
            statusColor = '#FF9900';
        } else if(id === 3) {
            statusColor = '#78A55A';
        }
        return statusColor;
    }

    deleteEvent = (eventId) => {
        const { dispatch } = this.props;
        dispatch({
            type: DELETE_EVENT_DETAILS,
            data: {
                eventId
            },
            onSuccess: this.getEventDetails
        })
    }

    onCreateNewEvent = () => {
        const { dispatch } = this.props;
        const event = new RFQ();
        event.rfqDetails.setServiceType(1, 'FTL');
        event.rfqDetails.setServiceModes([1]);
        event.rfqDetails.setInsuranceBy(1);
        event.biddingDetails.setPaymentTerms(2, 'To Be Billed');
        dispatch({
            type: CREATE_NEW_EVENT,
            data: event.getApiData()
        })
    }

    getEventStatusDetails = (event) => {
        const { history } = this.props;
        if(event.status === 1) {
            history.push(`/event/create/${event.event_id}/${event.rfq_id}`)
        } else {
            history.push(`/eventStatus/${event.event_id}`);
        }
    }

    onClickWinningTransporter = (event) => {
        const { history } = this.props;
        history.push(`/winningTransporters/${event.event_id}`);
    }

    downLoadEventDetails = (event) => {
        const { dispatch } = this.props;
        const branchLocalName = localStorage.getItem('branchDetail');
        const name = (branchLocalName && branchLocalName.length > 0) ? JSON.parse(localStorage.getItem('branchDetail')) : '';
    
        dispatch({
          type: DOWNLOAD_EVENT_DETAILS_TEMPLATE,
          data: {
            type: 3,
            rfqType: 1,
            eventId: event.event_id,
            branchId: name.branch_id,
          },
          onSuccess: (data) => {
            if(data.url) {
                downloadUrl(data.url);
            }
          }
        })
      } 

    render() {
        const { filter } = this.state;
        const { eventMagamentList, loader } = this.props;
        return (
            <Sticky>
                {loader && <ActionLoader />}
            <div className='bg-light-blue col-1 ht-100p pv-20 ph-20' style={{ backgroundColor: "#e3e9ff", height: "770px" }}>
                 <div className='flex flex-between'>
                    <div className='fBold fs-20'>Event Management</div>
                    <button className="wt-130 ht-30 white-color button-bg-color curP fBold fs-18" onClick={this.onCreateNewEvent}>New Event</button>
                 </div>

                 <div className='mt-10 col-1 flex'>
                    <div>
                        <input type="text" className='search-event pl-30 fs-16 mr-50' value={filter.search} placeholder='search' onChange={(e) => {
                            const { filter } = this.state;
                            filter.search = e.target.value;
                            this.setState({
                                filter
                            }, this.getEventDetails)
                        }}/>
                        <SearchIcon className="search-event-icon"/>
                    </div>
                    <div className='mr-50 event-c-date'>
                        <DateRangePicker
                            startDate={filter.from && Moment(filter.from) || null}
                            startDateId="startDate"
                            endDate={filter.to ? Moment(filter.to) : null}
                            endDateId="endDate"
                            onDatesChange={({ startDate, endDate }) => {
                                if(!startDate && !endDate) {
                                    const { filter } = this.state;
                                    filter['from'] = null;
                                    filter['to'] = null;
                                    this.setState({ filter }, () => {
                                            this.getEventDetails();
                                    })
                                } else {
                                    const { filter } = this.state;
                                    const startDateTime = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : new Date(filter.from).setHours(0, 0, 0, 0)
                                    filter['from'] = startDateTime;
                                    const endTime = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
                                    filter['to'] = endTime ? new Date(endTime).getTime() : filter['to'];
                                    this.setState({ filter }, () => {
                                        if(filter.from && filter.to) {
                                            this.getEventDetails();
                                        }
                                    })
                                }
                            }}
                            focusedInput={this.state.focusedInput}
                            onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
                            displayFormat={'DD MMM YYYY'}
                            className="wt-350"
                            noBorder={true}
                            isOutsideRange={() =>{ return false}}
                            minimumNights={0}
                            showClearDates={true}
                        />
                    </div>
                    <Dropdown
                        items={EVENT_STATUS} 
                        selectedItem={EVENT_STATUS.find(ev => ev.name === filter.eventId)} 
                        displayKey="name" 
                        name="salesType" 
                        label="All Events" 
                        onSelect={(option) => {
                            const { filter } = this.state;
                            filter.eventId = option.name;
                            this.setState({
                                filter
                            }, () => this.getEventDetails())
                        }}
                        className={Cx('event-select wt-300 br-5')}
                        canClear={true}
                    />
                 </div>
                 <div className="mt-30" style={{'maxHeight': '600px', 'overflow': 'auto'}}>
                    <table className='col-1 event-table' cellSpacing={0.5}>
                        <thead>
                            <tr>
                                <th>Event Id</th>
                                <th>RFQs</th>
                                <th>Status</th>
                                <th  width="200">Winning Transporters</th>
                                {/* <th>Date</th> */}
                                <th width="100"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {((eventMagamentList ||{}).event_status || []).map((event, eveIndex) => {
                                const bgColor = (eveIndex % 2 === 1) ? '#EFF2FD' : 'white';
                            return (
                            <tr>
                                <td style={{ 'backgroundColor': bgColor }} className="curP" onClick={() => this.getEventStatusDetails(event)}><div>{event.event_id}</div></td>
                                <td style={{ 'backgroundColor': bgColor }}><div>{event.number_of_rfqs}</div></td>
                                <td style={{ 'backgroundColor': bgColor, 'color': this.getStatusColor(event.status) }}><div style={{'color': this.getStatusColor(event.status)}} >{event.status_name}</div></td>
                                {/* <td style={{ 'backgroundColor': bgColor }}><div>{event.event_bid_start_date && Moment(event.event_bid_start_date).format('DD/MM/YYYY hh:mm a')}</div></td> */}
                                <td style={{ 'backgroundColor': bgColor }}>
                                    <WinningIcon className="theme-color curP wt-20 ht-25" onClick={() => this.onClickWinningTransporter(event)} />
                                </td>
                                <td style={{ 'backgroundColor': bgColor }}>
                                    <DownloadIcon className="theme-color curP wt-20 ht-25" onClick={() => this.downLoadEventDetails(event)}/>
                                    {[1].includes(event.status) && <DeleteIcon className="theme-color curP wt-20 ht-25" onClick={() => this.deleteEvent(event.event_id)}/>}
                                </td>
                            </tr>)})}
                        </tbody>
                    </table>

                 </div>
            </div>
            </Sticky>
        )
    }
}

const mapStateToProps = ({ contracting }) => {
    return {
        loader: contracting.loader || false,
        eventMagamentList: contracting.eventMagamentList || []
    }
}

export default connect(mapStateToProps)(eventManagement);
